module.exports = __webpack_public_path__ + "img/owl.7e0fb620.png";